import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import layout from "../../../actprep-ui/constants/layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { urls } from "../../../actprep-ui/utils/urls";
import { Box, Chip, Drawer, Tab, Tabs } from "@mui/material";
import { Tune } from "@mui/icons-material";
import { useFilters } from "../../../actprep-ui/hooks/ui";
import useDisclosure from "../../../actprep-ui/hooks/ui/useDisclosure";
import { goodNewsFilters } from "../../../constants/filters";
import ScoreGoodNews from "../../../components/ScoreGoodNews/";
import LTScoreGoodNews from "../../../components/LTScoreGoodNews/";
import QuizGoodNews from "../../../components/QuizGoodNews/";
import LtQuizGoodNews from "../../../components/LTQuizGoodNews/";

const GOOD_NEWS_TYPES = [
  "total-increase",
  "lt-total-increase",
  "quiz-score",
  "lt-quiz-score",
];

export default function GoodNews() {
  const { goodNewsType } = useParams();
  const navigate = useNavigate();
  const filtersDisc = useDisclosure();
  const { Filters, FiltersAppliedList, getFilterParams } = useFilters({
    name: "Good News Filters",
    filtersConfig: goodNewsFilters,
    handleClose: filtersDisc.onClose,
  });

  useEffect(() => {
    if (!GOOD_NEWS_TYPES.includes(goodNewsType)) {
      navigate(urls.error(404));
    }
  }, [goodNewsType, navigate]);

  const GoodNewsComponent = {
    "total-increase": ScoreGoodNews,
    "lt-total-increase": LTScoreGoodNews,
    "quiz-score": QuizGoodNews,
    "lt-quiz-score": LtQuizGoodNews,
  }[goodNewsType];

  return (
    <>
      <Drawer anchor="right" {...filtersDisc.getDisclosureProps()}>
        <Box
          sx={{ paddingTop: `${layout.navBarHeight + 1}rem`, width: "25rem" }}
        >
          <Filters />
        </Box>
      </Drawer>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
          height: "100%",
          pb: 5,
          mb: 4,
        }}
        size={12}
      >
        <Typography variant="h5" fontWeight={"bold"} my={1} color={"primary"}>
          Good News{" "}
          <Chip
            label="Filters"
            icon={<Tune />}
            {...filtersDisc.getButtonProps()}
          />
        </Typography>
        <FiltersAppliedList />
        <ContentBox sx={{ height: "80vh", minHeight: "fit-content" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Tabs
              value={goodNewsType}
              sx={{
                height: "5%",
              }}
              variant="scrollable"
              scrollButtons={false}
            >
              <Tab
                LinkComponent={Link}
                to={urls.admin.coaching.goodNews("total-increase")}
                label="Score"
                value={"total-increase"}
              />
              <Tab
                LinkComponent={Link}
                to={urls.admin.coaching.goodNews("lt-total-increase")}
                label="LT Score"
                value={"lt-total-increase"}
              />
              <Tab
                LinkComponent={Link}
                to={urls.admin.coaching.goodNews("quiz-score")}
                label="Quiz Score"
                value={"quiz-score"}
              />
              <Tab
                LinkComponent={Link}
                to={urls.admin.coaching.goodNews("lt-quiz-score")}
                label="LT Quiz Score"
                value={"lt-quiz-score"}
              />
            </Tabs>
          </Box>
          <Box mt={2} pb={4} sx={{ height: "95%" }}>
            <GoodNewsComponent filters={getFilterParams()} />
          </Box>
        </ContentBox>
      </Grid>
    </>
  );
}
